var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg305(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M451.426 562.123C596.193 562.123 713.549 444.767 713.549 300C713.549 155.233 596.193 37.877 451.426 37.877C306.659 37.877 189.303 155.233 189.303 300C189.303 444.767 306.659 562.123 451.426 562.123Z",
    fill: "url(#paint0_linear_197_34)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M708.475 240.202C695.848 262.737 668.194 265.833 623.89 261.551C590.57 258.324 560.185 255.827 526.863 237.659C503.54 224.952 485.078 207.76 471.603 191.062C457.001 172.973 436.62 152.328 446.611 131.817C460.341 103.643 539.744 79.913 616.847 118.718C701.545 161.359 720.828 218.177 708.475 240.202Z",
    fill: "url(#paint1_linear_197_34)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M793.833 287.316C770.045 299.116 738.473 283.943 738.473 283.943C738.473 283.943 745.489 249.646 769.29 237.862C793.077 226.062 824.637 241.218 824.637 241.218C824.637 241.218 817.62 275.516 793.833 287.316Z",
    fill: "url(#paint2_linear_197_34)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.142 373.556C149.223 392.184 193.815 374.964 193.815 374.964C193.815 374.964 187.984 327.548 156.884 308.941C125.803 290.312 81.23 307.512 81.23 307.512C81.23 307.512 87.06 354.928 118.142 373.556Z",
    fill: "url(#paint3_linear_197_34)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M747.028 195.257C739.854 195.257 734.039 201.072 734.039 208.246C734.039 215.42 739.854 221.235 747.028 221.235C754.202 221.235 760.017 215.42 760.017 208.246C760.017 201.072 754.202 195.257 747.028 195.257Z",
    fill: "#666AF6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M257.822 267.205C249.752 267.205 243.21 273.747 243.21 281.817C243.21 289.887 249.752 296.429 257.822 296.429C265.892 296.429 272.434 289.887 272.434 281.817C272.434 273.747 265.892 267.205 257.822 267.205Z",
    fill: "#666AF6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.929 208.109C153.204 208.109 147.752 202.657 147.752 195.932C147.752 189.207 153.204 183.755 159.929 183.755C166.654 183.755 172.106 189.207 172.106 195.932C172.106 202.657 166.654 208.109 159.929 208.109Z",
    fill: "#666AF6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M635.635 264.934C632.496 264.934 629.952 262.39 629.952 259.251C629.952 256.112 632.496 253.568 635.635 253.568C638.774 253.568 641.318 256.112 641.318 259.251C641.318 262.39 638.774 264.934 635.635 264.934Z",
    fill: "#666AF6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M668.43 520.116C664.395 520.116 661.124 516.845 661.124 512.81C661.124 508.775 664.395 505.504 668.43 505.504C672.465 505.504 675.736 508.775 675.736 512.81C675.736 516.845 672.465 520.116 668.43 520.116Z",
    fill: "#E1E4E5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M157.751 447.501C151.923 447.501 147.198 442.776 147.198 436.948C147.198 431.12 151.923 426.395 157.751 426.395C163.579 426.395 168.304 431.12 168.304 436.948C168.304 442.776 163.579 447.501 157.751 447.501Z",
    fill: "#E1E4E5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M279.793 175.335C275.357 175.335 271.761 171.739 271.761 167.303C271.761 162.867 275.357 159.271 279.793 159.271C284.229 159.271 287.825 162.867 287.825 167.303C287.825 171.739 284.229 175.335 279.793 175.335Z",
    fill: "#E1E4E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M669.743 177.723C664.811 177.723 660.813 173.725 660.813 168.793C660.813 163.861 664.811 159.863 669.743 159.863C674.675 159.863 678.673 163.861 678.673 168.793C678.673 173.725 674.675 177.723 669.743 177.723Z",
    fill: "#E1E4E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.678 268.053C190.825 272.331 188.286 276.728 184.008 277.875C179.73 279.021 175.333 276.482 174.187 272.204C173.041 267.926 175.579 263.529 179.857 262.383C184.135 261.237 188.532 263.775 189.678 268.053Z",
    fill: "#E1E4E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M385.553 110.589C379.661 110.589 374.885 105.813 374.885 99.9211C374.885 94.0293 379.661 89.2531 385.553 89.2531C391.445 89.2531 396.221 94.0293 396.221 99.9211C396.221 105.813 391.445 110.589 385.553 110.589Z",
    fill: "#E1E4E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M725.744 379.164C721.212 379.164 717.538 376.225 717.538 372.599C717.538 368.973 721.212 366.034 725.744 366.034C730.276 366.034 733.95 368.973 733.95 372.599C733.95 376.225 730.276 379.164 725.744 379.164Z",
    fill: "#E1E4E5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M587.091 95.1095C589.476 104.013 584.193 113.164 575.29 115.549C566.387 117.935 557.236 112.651 554.85 103.748C552.464 94.8454 557.748 85.6942 566.651 83.3086C575.554 80.9231 584.705 86.2065 587.091 95.1095Z",
    fill: "#E1E4E5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M787.973 327.261H788.187C789.458 345.272 802.853 345.549 802.853 345.549C802.853 345.549 788.083 345.837 788.083 366.649C788.083 345.837 773.312 345.549 773.312 345.549C773.312 345.549 786.701 345.272 787.973 327.261ZM248.445 502.359H248.635C249.763 518.66 261.649 518.911 261.649 518.911C261.649 518.911 248.543 519.172 248.543 538.007C248.543 519.172 235.437 518.911 235.437 518.911C235.437 518.911 247.317 518.66 248.445 502.359Z",
    fill: "#E1E4E5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M679.136 128.304H225.732C223.416 128.304 221.538 130.182 221.538 132.498V468.452C221.538 470.768 223.416 472.646 225.732 472.646H679.136C681.453 472.646 683.33 470.768 683.33 468.452V132.498C683.33 130.182 681.453 128.304 679.136 128.304Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.322 130.304C224.11 130.304 223.128 131.286 223.128 132.498V468.452C223.128 469.664 224.11 470.646 225.322 470.646H678.726C679.938 470.646 680.92 469.664 680.92 468.452V132.498C680.92 131.286 679.938 130.304 678.726 130.304H225.322ZM219.128 132.498C219.128 129.077 221.901 126.304 225.322 126.304H678.726C682.147 126.304 684.92 129.077 684.92 132.498V468.452C684.92 471.873 682.147 474.646 678.726 474.646H225.322C221.901 474.646 219.128 471.873 219.128 468.452V132.498Z",
    fill: "#E1E4E5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M678.726 128.304H225.322C223.006 128.304 221.128 130.182 221.128 132.498V164.15C221.128 166.466 223.006 168.344 225.322 168.344H678.726C681.042 168.344 682.92 166.466 682.92 164.15V132.498C682.92 130.182 681.042 128.304 678.726 128.304Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.322 130.304C224.11 130.304 223.128 131.286 223.128 132.498V164.15C223.128 165.362 224.11 166.344 225.322 166.344H678.726C679.938 166.344 680.92 165.362 680.92 164.15V132.498C680.92 131.286 679.938 130.304 678.726 130.304H225.322ZM219.128 132.498C219.128 129.077 221.901 126.304 225.322 126.304H678.726C682.147 126.304 684.92 129.077 684.92 132.498V164.15C684.92 167.571 682.147 170.344 678.726 170.344H225.322C221.901 170.344 219.128 167.571 219.128 164.15V132.498Z",
    fill: "#E1E4E5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M243.818 141.65H243.817C240.132 141.65 237.144 144.638 237.144 148.323V148.324C237.144 152.009 240.132 154.997 243.817 154.997H243.818C247.503 154.997 250.491 152.009 250.491 148.324V148.323C250.491 144.638 247.503 141.65 243.818 141.65Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.817 143.747C241.29 143.747 239.241 145.796 239.241 148.323V148.324C239.241 150.851 241.29 152.9 243.817 152.9H243.818C246.345 152.9 248.394 150.851 248.394 148.324V148.323C248.394 145.796 246.345 143.747 243.818 143.747H243.817ZM235.047 148.323C235.047 143.479 238.973 139.553 243.817 139.553H243.818C248.661 139.553 252.588 143.479 252.588 148.323V148.324C252.588 153.168 248.661 157.094 243.818 157.094H243.817C238.973 157.094 235.047 153.168 235.047 148.324V148.323Z",
    fill: "#E1E4E5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M267.842 141.65H267.841C264.156 141.65 261.168 144.638 261.168 148.323V148.324C261.168 152.009 264.156 154.997 267.841 154.997H267.842C271.527 154.997 274.515 152.009 274.515 148.324V148.323C274.515 144.638 271.527 141.65 267.842 141.65Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.841 143.747C265.314 143.747 263.265 145.796 263.265 148.323V148.324C263.265 150.851 265.314 152.9 267.841 152.9H267.842C270.369 152.9 272.418 150.851 272.418 148.324V148.323C272.418 145.796 270.369 143.747 267.842 143.747H267.841ZM259.071 148.323C259.071 143.479 262.998 139.553 267.841 139.553H267.842C272.686 139.553 276.612 143.479 276.612 148.323V148.324C276.612 153.168 272.686 157.094 267.842 157.094H267.841C262.998 157.094 259.071 153.168 259.071 148.324V148.323Z",
    fill: "#E1E4E5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M291.865 141.65H291.864C288.179 141.65 285.191 144.638 285.191 148.323V148.324C285.191 152.009 288.179 154.997 291.864 154.997H291.865C295.55 154.997 298.538 152.009 298.538 148.324V148.323C298.538 144.638 295.55 141.65 291.865 141.65Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 363.461,
    y: 211.154,
    width: 114.231,
    height: 27.6923,
    rx: 1,
    fill: "#E1E4E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 481.154,
    y: 211.154,
    width: 62.3077,
    height: 27.6923,
    rx: 1,
    fill: "#F5F5F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 401.538,
    y: 249.231,
    width: 141.923,
    height: 27.6923,
    rx: 1,
    fill: "#E1E4E5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 363.461,
    y: 249.231,
    width: 31.1538,
    height: 27.6923,
    rx: 1,
    fill: "#F5F5F5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 429.231,
    y: 363.462,
    width: 114.231,
    height: 27.6923,
    rx: 1,
    fill: "#E1E4E5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 363.461,
    y: 363.462,
    width: 62.3077,
    height: 27.6923,
    rx: 1,
    fill: "#F5F5F5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 363.462,
    y: 401.538,
    width: 141.923,
    height: 27.6923,
    rx: 1,
    fill: "#E1E4E5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 512.308,
    y: 401.538,
    width: 31.1538,
    height: 27.6923,
    rx: 1,
    fill: "#F5F5F5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 363.461,
    y: 287.308,
    width: 86.5385,
    height: 27.6923,
    rx: 1,
    fill: "#E1E4E5"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 456.923,
    y: 287.308,
    width: 86.5385,
    height: 27.6923,
    rx: 1,
    fill: "#F5F5F5"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 456.923,
    y: 325.385,
    width: 86.5385,
    height: 27.6923,
    rx: 1,
    fill: "#E1E4E5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 363.462,
    y: 325.385,
    width: 86.5385,
    height: 27.6923,
    rx: 1,
    fill: "#F5F5F5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.864 143.747C289.337 143.747 287.288 145.796 287.288 148.323V148.324C287.288 150.851 289.337 152.9 291.864 152.9H291.865C294.392 152.9 296.441 150.851 296.441 148.324V148.323C296.441 145.796 294.392 143.747 291.865 143.747H291.864ZM283.094 148.323C283.094 143.479 287.02 139.553 291.864 139.553H291.865C296.709 139.553 300.635 143.479 300.635 148.323V148.324C300.635 153.168 296.709 157.094 291.865 157.094H291.864C287.02 157.094 283.094 153.168 283.094 148.324V148.323Z",
    fill: "#E1E4E5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M536.748 330.104C536.748 326.676 537.853 324.12 540.064 322.437C542.295 320.753 545.246 319.8 548.918 319.577L554.181 319.364L556.645 319.273V316.595C556.625 315.703 556.27 315.003 555.58 314.496C554.911 313.989 554.008 313.736 552.873 313.736C551.676 313.736 550.713 313.999 549.982 314.527C549.252 315.034 548.816 315.804 548.674 316.839H538.026C538.168 314.77 538.817 312.904 539.973 311.241C541.149 309.557 542.843 308.229 545.054 307.255C547.264 306.262 549.932 305.765 553.055 305.765C556.057 305.765 558.694 306.231 560.965 307.164C563.257 308.077 565.022 309.365 566.259 311.028C567.517 312.671 568.145 314.547 568.145 316.656V339.231H557.375V334.606H557.132C556.158 336.371 554.87 337.669 553.268 338.501C551.686 339.332 549.769 339.758 547.518 339.778C544.232 339.758 541.616 338.937 539.669 337.314C537.722 335.691 536.748 333.288 536.748 330.104ZM547.579 329.434C547.599 330.408 547.944 331.148 548.613 331.655C549.283 332.162 550.175 332.416 551.291 332.416C552.264 332.416 553.167 332.213 553.998 331.807C554.83 331.402 555.489 330.834 555.976 330.104C556.463 329.353 556.706 328.481 556.706 327.487V325.723C554.292 325.783 552.386 325.885 550.986 326.027C549.952 326.169 549.13 326.554 548.522 327.183C547.914 327.791 547.599 328.542 547.579 329.434Z",
    fill: "#666AF6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M533.402 314.527H527.621V328.643C527.621 329.455 527.834 330.033 528.26 330.377C528.706 330.722 529.406 330.895 530.359 330.895C531.17 330.895 532.327 330.834 533.827 330.712V339.292C532.55 339.555 530.724 339.697 528.351 339.718C524.274 339.697 521.202 338.886 519.133 337.284C517.084 335.681 516.08 333.187 516.121 329.799V314.527H511.862V306.191H516.121V298.281H527.621V306.191H533.402V314.527Z",
    fill: "#666AF6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M476.752 330.104C476.752 326.676 477.858 324.12 480.069 322.437C482.3 320.753 485.251 319.8 488.922 319.577L494.185 319.364L496.65 319.273V316.595C496.629 315.703 496.274 315.003 495.585 314.496C494.915 313.989 494.013 313.736 492.877 313.736C491.68 313.736 490.717 313.999 489.987 314.527C489.257 315.034 488.821 315.804 488.679 316.839H478.03C478.172 314.77 478.821 312.904 479.977 311.241C481.154 309.557 482.847 308.229 485.058 307.255C487.269 306.262 489.936 305.765 493.06 305.765C496.061 305.765 498.698 306.231 500.97 307.164C503.262 308.077 505.026 309.365 506.263 311.028C507.521 312.671 508.15 314.547 508.15 316.656V339.231H497.38V334.606H497.136C496.163 336.371 494.875 337.669 493.272 338.501C491.69 339.332 489.774 339.758 487.522 339.778C484.237 339.758 481.62 338.937 479.673 337.314C477.726 335.691 476.752 333.288 476.752 330.104ZM487.583 329.434C487.604 330.408 487.948 331.148 488.618 331.655C489.287 332.162 490.179 332.416 491.295 332.416C492.269 332.416 493.171 332.213 494.003 331.807C494.834 331.402 495.493 330.834 495.98 330.104C496.467 329.353 496.71 328.481 496.71 327.487V325.723C494.297 325.783 492.39 325.885 490.991 326.027C489.956 326.169 489.135 326.554 488.526 327.183C487.918 327.791 487.604 328.542 487.583 329.434Z",
    fill: "#666AF6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M433.916 339.231V295.177H450.527C455.03 295.177 458.934 296.06 462.24 297.824C465.546 299.568 468.092 302.104 469.877 305.43C471.662 308.736 472.554 312.661 472.554 317.204C472.554 321.747 471.662 325.672 469.877 328.978C468.112 332.284 465.577 334.819 462.271 336.584C458.985 338.348 455.111 339.231 450.649 339.231H433.916ZM450.223 329.373C452.576 329.373 454.533 328.998 456.095 328.248C457.657 327.477 458.843 326.199 459.654 324.414C460.466 322.63 460.871 320.226 460.871 317.204C460.871 314.162 460.456 311.748 459.624 309.963C458.813 308.178 457.606 306.911 456.004 306.16C454.422 305.41 452.393 305.035 449.919 305.035H445.477V329.373H450.223Z",
    fill: "#666AF6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M398.503 339.839C395.014 339.839 391.982 339.129 389.406 337.71C386.851 336.29 384.883 334.302 383.504 331.746C382.145 329.171 381.466 326.189 381.466 322.802C381.466 319.415 382.145 316.443 383.504 313.888C384.883 311.312 386.851 309.314 389.406 307.894C391.982 306.475 395.014 305.765 398.503 305.765C401.991 305.765 405.014 306.475 407.569 307.894C410.145 309.314 412.102 311.312 413.441 313.888C414.8 316.443 415.479 319.415 415.479 322.802C415.479 326.189 414.8 329.171 413.441 331.746C412.102 334.302 410.145 336.29 407.569 337.71C405.014 339.129 401.991 339.839 398.503 339.839ZM393.209 322.741C393.229 325.378 393.706 327.467 394.639 329.008C395.572 330.53 396.88 331.3 398.564 331.321C400.166 331.3 401.424 330.54 402.336 329.039C403.269 327.518 403.736 325.459 403.736 322.863C403.736 320.165 403.279 318.036 402.367 316.474C401.454 314.912 400.186 314.141 398.564 314.162C396.88 314.141 395.572 314.902 394.639 316.443C393.706 317.965 393.229 320.064 393.209 322.741Z",
    fill: "#666AF6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M376.659 339.231H366.984L350.616 315.439H350.312V339.231H338.751V295.177H348.608L364.733 318.847H365.098V295.177H376.659V339.231Z",
    fill: "#666AF6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_34",
    x1: 462.603,
    y1: 856.045,
    x2: 446.439,
    y2: -532.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_197_34",
    x1: 623.412,
    y1: 386.251,
    x2: 510.865,
    y2: -119.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_197_34",
    x1: 702.485,
    y1: 324.123,
    x2: 898.687,
    y2: 168.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_197_34",
    x1: 238.418,
    y1: 433.519,
    x2: -11.673,
    y2: 201.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg305);
export default __webpack_public_path__ + "static/media/305.0b3c2f80e268ba7156a8d8640360b813.svg";
export { ForwardRef as ReactComponent };